// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_Gle","cls2":"CreateSocialItemModal-cls2_UOT CreateSocialItemModal-cls1_Gle","center":"CreateSocialItemModal-center_y_r"};